document.addEventListener("DOMContentLoaded", function() {
  const product_list_container = document.querySelector('.product__media-list')
  const product_items = product_list_container.querySelectorAll('.product__media-item')
  const tracking_container = document.querySelector('.slider-tracking');
  const dots = tracking_container.querySelectorAll('.slider-tracking--count');


  const handleTouchEnd = () => {
    let minPositiveLeft = Infinity;
    dots.forEach((dot) => {
      dot.classList.remove(['current-count'])
    })

    setTimeout(() => {
      
      product_items.forEach((product, index) => {
        const rect = product.getBoundingClientRect()
  
        if (rect.left >= 0) {
          
          // Update currentIndex if this is the smallest positive `rect.left` seen so far
          if (rect.left < minPositiveLeft) {
            minPositiveLeft = rect.left;
            dots[index].classList.add('current-count')
  
          }
        }
      })
    }, 50)
  }
  
  product_list_container.addEventListener('touchend', handleTouchEnd);
})